import React, { Fragment } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    ModalFooter,
    Card
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
export default function ViewOrders({
    isopen,
    orderData,
    toggle,
    subOrderList
}) {
    const dataTableColumns = [
        {
            Header: 'Voucher Name',
            accessor: 'name',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Voucher Number',
            accessor: 'voucherNumber',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Order Item Id',
            accessor: 'orderItemId',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>
        },
        {
            Header: 'Quantity',
            accessor: 'quantity',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Customer Email',
            accessor: 'email',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Price',
            accessor: 'amount',
            Cell: props => <p style={{ marginLeft: "19%" }} >${props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Discount',
            accessor: 'discount',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}%</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Discounted Price',
            accessor: 'discountedPrice',
            Cell: props => <p style={{ marginLeft: "19%" }} >${props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Created Date',
            accessor: 'createdDate',
            Cell: props => <p style={{ marginLeft: "19%" }} >{moment(props.value).format("DD-MM-YYYY hh:mm:ss A")}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        }
    ];
    return (
        <Fragment>
            <Modal
                isOpen={isopen}
                toggle={toggle}
                size="lg"
                style={{ maxWidth: '90%' }}
            >
                <ModalHeader toggle={toggle}>Order Details</ModalHeader>
                <ModalBody>
                    <Row className="mb-3">
                        <Colxx xxs={4} className="mb-3">
                            <Label><b>Order Number</b></Label>
                            <div>{subOrderList.orderNumber}</div>
                        </Colxx>
                        <Colxx xxs={4} className="mb-3">
                            <Label><b>Order Date</b></Label>
                            <div>{moment(subOrderList.creadtedDate).format('LL')}</div>
                        </Colxx>
                        <Colxx xxs={4} className="mb-3">
                            <Label><b>No. of Items</b></Label>
                            <div>{orderData.length}</div>
                        </Colxx>
                        <Colxx xxs={4} className="mb-3">
                            <Label><b>Grand Total</b></Label>
                            <div>
                                {subOrderList.currency !== undefined && subOrderList.currency.toUpperCase()} {orderData.reduce((a, b) => a + b.discountedPrice, 0)}
                            </div>
                        </Colxx>
                        <Colxx xxs={4} className="mb-3">
                            <Label><b>Order Status</b></Label>
                            <div>{subOrderList.status}</div>
                        </Colxx>
                        <Colxx xxs={4} className="mb-3">
                            <Label><b>Order Email</b></Label>
                            <div>{subOrderList.email}</div>
                        </Colxx>
                    </Row>
                    <h2>Items</h2>
                    {orderData.map((item, index) => (
                        <Row className="mb-3" key={index}>
                            {item.images.length > 0 && <Colxx xxs={2} className="mb-3">
                                <div>
                                    <img src={item.images} className="list-thumbnail responsive border-0"></img>
                                </div>    </Colxx>}
                            {item.voucherNumber.length > 0 && <Colxx xxs={2} className="mb-3">
                                <Label><b>Voucher Number</b></Label><div>
                                    {item.voucherNumber}</div>
                            </Colxx>}
                            <Colxx xxs={1} className="mb-3">
                                <Label><b>Price</b></Label>
                                <div>  {item.currency.toUpperCase()} {item.amount}</div>
                            </Colxx>
                            {item.name.length > 0 && <Colxx xxs={2} className="mb-3">
                                <Label><b>Voucher Name</b></Label>
                                <div> {item.name}</div>
                            </Colxx>}
                            <Colxx xxs={1} className="mb-3">
                                <Label><b>Discount</b></Label>
                                <div> {item.discount} %</div>
                            </Colxx>
                            <Colxx xxs={1} className="mb-3">
                                <Label><b>Quantity</b></Label>
                                <div> {item.quantity}</div>
                            </Colxx>
                            <Colxx xxs={2} className="mb-3">
                                <Label><b>Discounted Price</b></Label>
                                <div>  {item.currency.toUpperCase()} {item.discountedPrice}</div>
                            </Colxx>
                        </Row>
                    ))}
                    <br />
                    {subOrderList.paymentDetail.length > 0 && <h2>Payments</h2>}
                    {subOrderList.paymentDetail.length > 0 && subOrderList.paymentDetail.map((item, index) => (
                        <Row className="mb-3" key={index}>
                            <Colxx xxs={2} className="mb-3">
                                <Label><b>Payment Type</b></Label>
                                <div> {item.type} </div>
                            </Colxx>
                            <Colxx xxs={2} className="mb-3">
                                <Label><b>Payment Provider</b></Label>
                                <div> {item.provider} </div>
                            </Colxx>
                            <Colxx xxs={1} className="mb-3">
                                <Label><b>Amount</b></Label>
                                <div>  {item.currency.toUpperCase()} {item.amount}</div>
                            </Colxx>
                            <Colxx xxs={2} className="mb-3">
                                <Label><b>Payment Id</b></Label>
                                <div> {item.paymentId} </div>
                            </Colxx>
                            <Colxx xxs={1} className="mb-3">
                                <Label><b>Status</b></Label>
                                <div> {item.status}</div>
                            </Colxx>
                            <Colxx xxs={2} className="mb-3">
                                <Label><b>Payment Email</b></Label>
                                <div> {item.receiptEmail}</div>
                            </Colxx>
                            <Colxx xxs={2} className="mb-3">
                                <Label><b>Payment Method</b></Label>
                                <div> {item.method}</div>
                            </Colxx>
                        </Row>
                    ))}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}